import { useHistory } from 'react-router';
import checkMark from '../../../utils/assests/checkMark.png';
import fail_status from '../../../utils/assests/fail_status.svg';
import InfoFormP2p from '../../../Common/InfoFormP2p';
import { useDispatch } from 'react-redux';
import { getTransactionConfirmation } from '../InvestFund/investFundAction';
import { useEffect } from 'react';
import { logFirebaseEvent } from '../firebase';
import {
  P2P_PG_SUCCESSFUL_PAYMENT_BTN,
  P2P_PG_SUCCESSFUL_PAYMENT_VIEW,
} from '../firebase/constant';
import CongraImg from '../../../utils/assests/payment-congrates.png';
import FailedImg from '../../../utils/assests/failed-screen-image.png';
const PaymentSuccess = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    logFirebaseEvent(P2P_PG_SUCCESSFUL_PAYMENT_VIEW);
  }, []);

  const handleSContinue = () => {
    logFirebaseEvent(P2P_PG_SUCCESSFUL_PAYMENT_BTN);
    history.push({ pathname: '/p2p/dashboard' });
  };

  // useEffect(() => {
  //   dispatch(getTransactionConfirmation());
  // },[]);

  return (
    <>
      <InfoFormP2p
        imgShow={CongraImg}
        imgFail={FailedImg}
        // title={`welcome to Stashearn <span></span> continue to start investing today!`}
        btnTitle='Back to dashboard'
        handleSContinue={handleSContinue}
        showBtn={true}
      />
    </>
  );
};

export default PaymentSuccess;
